import React, { useState } from 'react';
import { Navbar, Nav, Button, Modal, Form, NavDropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Imagedonatelogo from '../images/website_logo.png';
import { login } from '../api';

const Header: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [loginData, setLoginData] = useState({
    adminId: '',
    password: '',
  });
  const navigate = useNavigate();

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleLoginSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await login(loginData);
      localStorage.setItem('token', res.data.token);
      alert('Login successful!');
      handleClose();
      setLoginData({ adminId: '', password: '' });
      navigate('/dashboard');
    } catch (err: any) {
      alert(err.message || 'Error logging in. Please try again.');
    }
  };

  const handleNavLinkClick = () => {
    const navbarToggler = document.querySelector('.navbar-toggler') as HTMLButtonElement | null;
    const navbarCollapse = document.querySelector('.navbar-collapse');
    if (navbarCollapse?.classList.contains('show') && navbarToggler) {
      navbarToggler.click();
    }
  };

  return (
    <>
      <Navbar bg="light" variant="light" expand="lg" fixed="top" className="header px-5">
        <Navbar.Brand as={Link} to="/">
          <img src={Imagedonatelogo} alt="NGO Logo" className="header-logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="bg-dark border-dark" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Home
            </Nav.Link>
            <NavDropdown title="About Us" id="about-us-dropdown" className="nav-link-custom">
              <NavDropdown.Item as={Link} to="/about/" onClick={handleNavLinkClick}>
                Who We Are
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/core-team/" onClick={handleNavLinkClick}>
                Core Team
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/mentors/" onClick={handleNavLinkClick}>
                Mentors
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Our Mission" id="our-mission-dropdown" className="nav-link-custom">
              <NavDropdown.Item as={Link} to="/education/" onClick={handleNavLinkClick}>
                Educations
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/women-empowerment/" onClick={handleNavLinkClick}>
                Women Empowerments
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/environment/" onClick={handleNavLinkClick}>
                Environment
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/health/" onClick={handleNavLinkClick}>
                Health
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/livelihood/" onClick={handleNavLinkClick}>
                Livelihood
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to="/media/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Media
            </Nav.Link>
            <Nav.Link as={Link} to="/blogs/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Blogs
            </Nav.Link>
            <Nav.Link as={Link} to="/contact/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Contact Us
            </Nav.Link>
            <Link to="/donate/" className="nav-link-custom" onClick={handleNavLinkClick}>
              <Button variant="danger" className="header-donate-btn">
                Donate US
              </Button>
            </Link>
            <Button variant="outline-dark" className="header-login-btn ms-2" onClick={handleShow}>
              <i className="fas fa-sign-in-alt me-2"></i> Login
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="login-modal-title">Admin Login</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleLoginSubmit}>
            <Form.Group className="mb-3" controlId="formAdminId">
              <Form.Label>Admin ID</Form.Label>
              <Form.Control
                type="text"
                name="adminId"
                value={loginData.adminId}
                onChange={handleChange}
                placeholder="Enter Admin ID"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                value={loginData.password}
                onChange={handleChange}
                placeholder="Enter Password"
                required
              />
            </Form.Group>
            <div className="text-center">
              <Button variant="primary" type="submit" className="login-submit-btn">
                Login
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;